export type ReportTable = { name: string; columns: string[]; rows: Record<string, unknown>[] }

export function reportTables(value: unknown): ReportTable[] {
  if (!Array.isArray(value)) return []
  return value.flatMap((item) => {
    if (!item || typeof item !== "object" || !Array.isArray(item.rows)) return []
    const columns: string[] = Array.isArray(item.columns) ? item.columns.flatMap((column: unknown) => typeof column === "string" ? [column] : column && typeof column === "object" && "name" in column && typeof column.name === "string" ? [column.name] : []) : []
    const headers = columns.length ? columns : item.rows[0] && typeof item.rows[0] === "object" && !Array.isArray(item.rows[0]) ? Object.keys(item.rows[0]) : []
    const rows = item.rows.map((row: unknown) => Array.isArray(row) ? Object.fromEntries(headers.map((header, index) => [header, row[index]])) : row && typeof row === "object" ? row as Record<string, unknown> : {})
    return [{ name: typeof item.name === "string" ? item.name : "", columns: [...new Set(headers)], rows }]
  })
}

export function reportCell(value: unknown) {
  if (value == null) return "—"
  if (typeof value === "object") return JSON.stringify(value)
  return String(value)
}

export function filterReportRows(table: ReportTable, query: string, clientColumn?: string, client?: string) {
  const term = query.trim().toLowerCase()
  if (!term && !client) return table.rows
  return table.rows.filter((row) => (!client || !clientColumn || String(row[clientColumn] ?? "") === client) && (!term || table.columns.some((column) => reportCell(row[column]).toLowerCase().includes(term))))
}
